import { ChangeDetectionStrategy, Component, computed, inject, model, output, Signal, signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { AbstractToggleFormComponent } from '@spike/scaffolds';
import { FormFactoryService } from '../../../shared/services/form-factory.service';
import { FormGroup } from '@angular/forms';
import { ResourceApiService } from '@spike/core';
import { EquipmentRequestFormComponent } from "../../forms/equipment-request-form/equipment-request-form";
import { OrganizationStoreService } from '../../../organizations/services/organization-store.service';
import { Tag } from "primeng/tag";
import { WorkflowApiService } from '../../../workflow/services/workflow-api.service';
import { CommonModule } from '@angular/common';
import { EquipmentRequest } from '../../models/equipment-request.model';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { EquipmentRequestWorkflow } from 'src/app/features/workflow/models/workflow-status.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-equipment-request-side-panel',
  providers:[],
  imports: [Button, CommonModule, Drawer, EquipmentRequestFormComponent, Tag],
  templateUrl: './equipment-request-side-panel.html'
})
export class EquipmentRequestSidePanelComponent extends AbstractToggleFormComponent<EquipmentRequest>{

  private readonly workflowApiService = inject(WorkflowApiService);
  private readonly resourceApi = inject(ResourceApiService);
  private readonly formFactory = inject(FormFactoryService);
  private readonly organizationStore = inject(OrganizationStoreService);

  isDialogVisible = model.required<boolean>();
  dataId = model.required<number>();

  //output
  public readonly onDelete = output<void>();
  public readonly onSave = output<void>();
  public readonly onClose = output<void>();

  public override form: FormGroup<any> =this.formFactory.equipmentRequestForm();

  override disabledFields: Signal<string[]> = signal([]);

  protected override buildFormArrays(data: EquipmentRequest): void {}


  public readonly orderResource = this.resourceApi.selectById<EquipmentRequest>(signal(EntityApiEnum.EQUIPMENT_REQUEST), this.dataId);
  
  
  public readonly data = computed(()=>{
    const orderResource= this.orderResource.value();
    return orderResource;
  })

  
  public readonly dialogHeader= computed (()=>{
    const isFormView = this.formView();
    return !isFormView ? 'Dettaglio': 'Modifica';
    
  });

  public readonly equipmentData= computed (()=>{
    const data = this.data();
    return this.organizationStore.getEquipment(data?.equipmentId!)();
  });

  async onSaveClicked() {
    this.form.markAllAsTouched();

      if (this.form.valid) {
        const generalValues = this.form.getRawValue();
        const toSaveData: any = {
          ...generalValues,
          requestId: this.dataId(),
        };

        await this.workflowApiService.updateEquipmentRequest(toSaveData);
        this.formView.set(false);
        this.orderResource.reload();
        this.onSave.emit();
      }
  }


   getRequestStatusSeverity(stateId:number): 'secondary' | 'success' | 'info' | 'warn' | 'danger' {  
      return EquipmentRequestWorkflow.find(x => x.id == stateId)?.severity ?? 'info';
    }
  
    getRequestStatusDescription(stateId:number): string | undefined {
      return EquipmentRequestWorkflow.find(x => x.id == stateId)?.label;
    } 

}